import React from 'react';
import { Icon, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container } from 'styles';
import { Image } from './spotlight.style';

const getCopy = copyFor('usage.windDetails');

interface Props {
  project: {
    description?: string;
    imageUrl?: string;
    latitude?: number;
    location?: string;
    longitude?: number;
    name?: string;
    state?: string;
    projectType: string;
  };
}

export const Spotlight = ({ project }: Props) => {
  const { description, imageUrl, location, name, projectType, state } = project;

  return (
    <Container flex direction="column">
      <Image src={imageUrl} alt={getCopy('alt', { projectType })} />
      <Container
        margin={{ bottom: '24px', right: '24px', top: '40px' }}
        small={{ right: 0 }}
      >
        <Text textStyle="heading800" tag="h2" margin={{ bottom: '8px' }}>
          {name}
        </Text>
        <Container flex alignItems="center" margin={{ bottom: '24px' }}>
          <Icon icon="Location" color="secondary" margin={{ right: '8px' }} />
          <Text textStyle="paragraph400" opacity="medium">
            {location}, {state}
          </Text>
        </Container>
        <Text opacity="medium">{description}</Text>
      </Container>
    </Container>
  );
};
